module.exports = __webpack_public_path__ + "assets/632f1fe2aafa3ed94633a2d39e1f5507.mp4";